import React, {useEffect, useMemo, useState} from "react";
import {navButtons, projectTexts} from "../../constants/copyright";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import {safeHTML} from "../../utils/safeHTML";
import Tag from "../baseComponents/gui/tag/Tag";
import ProjectToggle from "./ProjectToggle";
import ProjectList from "./ProjectList";
import {CSSTransition, SwitchTransition} from "react-transition-group";
import classNames from "classnames";
import {usePanel} from "../../redux/reducer/panel";
import Recommendations from "../recommendations/Recommendations";
import Collapse, {Panel} from "rc-collapse";
import styles from "./Project.module.scss";


const getCollapsedHeight = () => ({height: 0, opacity: 0});
const getRealHeight = (node) => ({height: node.scrollHeight, opacity: 1});
const getCurrentHeight = (node) => ({height: node.offsetHeight});
const skipOpacityTransition = (_, event) => event.propertyName === 'height';
const openMotion = {
  motionName: 'rc-collapse-motion',
  onEnterStart: getCollapsedHeight,
  onEnterActive: getRealHeight,
  onLeaveStart: getCurrentHeight,
  onLeaveActive: getCollapsedHeight,
  onEnterEnd: skipOpacityTransition,
  onLeaveEnd: skipOpacityTransition,
  motionDeadline: 500,
  leavedClassName: 'rc-collapse-content-hidden',
};


const Project = React.forwardRef(
  function Project({title, preview, tags, content, links, header_image, comments, recommendation}, ref) {

    const [activeKeys, setActiveKeys] = useState([]);

    const {buttonBack, buttonToTop} = navButtons;

    const [season, setSeason] = useState(0);
    const [slide, setSlide] = useState(0);
    const {stub} = projectTexts;


    const {filter} = usePanel()

    const handleChange = (keys) => {
      setActiveKeys(keys);
    };

    const isPanelActive = (key) => {
      return activeKeys?.includes(key);
    };

    const seasonData = useMemo(() => content?.seasons[season]?.episodes, [season]);
    // const likes = useMemo(() => details.tags.filter(({type}) => type === 'likes')?.[0], [details]);


    useEffect(() => {
      setSlide(0);
    }, [season]);

    const newTags = tags.filter(({type}) => type !== "tag");

    const activeItem = {
      ...seasonData[slide],
    };

    //-console.log("activeItem", activeItem)

    return (
      <section className={styles.project} ref={ref}>
        <div className={styles.project__content}>
          <Button {...buttonBack}
                  routerUrl={filter === '/' ? filter : '/' + filter}
                  className={classNames("news__back", buttonBack.className)}/>
          <div className={styles.project__header}>
            <h1 className={styles.project__title}>{safeHTML(title)}</h1>
            <div className={styles.project__tags}>
              {tags?.map((el, id) => <Tag key={`tag-p-${id}`} {...el}/>)}
            </div>
          </div>
          <div className={styles.project__banner}>
            <a href={''}
               target={'_blank'}
               className={styles.project__bannerLink}
            >
              {header_image && <img src={header_image} alt={''} loading="eager" fetchpriority={"high"}/>}
            </a>
          </div>
          <div className={styles.project__main}>
            <div className={styles.project__videos}>
              <div className={classNames(styles.project__videosBg, {
                [styles.project__videosBg_dark]: seasonData,
                [styles.project__videosBg_light]: !seasonData,
              })}/>
              {content?.seasons?.length > 1 && <ProjectToggle max={content?.seasons?.length} season={season}
                                                              setSeason={setSeason}/>}
              {seasonData ? <>
                  <ProjectList season={seasonData} {...{slide, setSlide}}/>
                  <SwitchTransition>
                    <CSSTransition key={`${season}-${slide}`} timeout={300} classNames={'project__release'} appear>
                      <div className={styles.project__release}>
                        <div className={styles.project__releaseVideo}>
                          <iframe width={"100%"} height={"100%"} src={seasonData[slide]?.video}
                                  title={"YouTube video player"}
                                  allow={"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"}
                                  frameBorder={"0"} allowFullScreen>
                          </iframe>
                        </div>
                      </div>
                    </CSSTransition>
                  </SwitchTransition>
                </>
                :
                <div className={styles.project__stub}>
                  <h2 className={styles.project__stubTitle}>{safeHTML(stub)}</h2>
                </div>
              }
            </div>
            {activeItem?.text
              ? <Collapse
                className={styles.project__readMore}
                accordion={true}
                openMotion={openMotion}//анимированное раскрытие элемента из constants/collapse
                onChange={handleChange}
              >
                <Panel header={isPanelActive('1') ? 'Скрыть текст' :`Читать больше`} key={"1"}
                       showArrow={false}

                       headerClass={classNames(
                         buttonStyles.button,
                         buttonStyles.button_black,
                         buttonStyles.button_big,
                       )}>
                  {activeItem?.text}
                </Panel>

              </Collapse> : <></>}
            {seasonData ? <div className={styles.project__footer}>
              {/*<Tag {...likes} mod={'main'}/>*/}
              <div className={styles.project__socials}>
                {links.map(({color_image, url}, id) =>
                  <a key={`soc-p-${id}`}
                     className={classNames(styles.project__soc,{
                       [styles[`project__soc_${id + 1}`]]: id + 1,
                     })}
                     href={url}
                     target={'_blank'}>
                    <img src={color_image} alt="" loading="lazy"/>
                  </a>)}
              </div>
            </div> : <></>}
          </div>

          {/*-<AppearSensor partialVisibility={true}>*/}
          {/*  {({hasBeenVisible}) =>*/}
          {/*    <Comments comments={comments} className={classNames("", {*/}
          {/*      "comments_show": hasBeenVisible*/}
          {/*    })}/>*/}
          {/*  }*/}
          {/*</AppearSensor>*/}
          <Recommendations title={"Рекомендуем"} list={recommendation} mod={"project"} showAnimation={true}/>
          <Button {...buttonToTop}
                  className={classNames("news__to-top", buttonToTop.className)}
                  onClick={() => scrollTo({top: 0, behavior: "smooth"})}

          />
        </div>
      </section>
    );
  });
export default Project;
Project.propTypes = {};

